es-typeahead {
    display: block;
}

.typeahead {
    display: flex;
    width: 100%;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: var(--color-shade-50);
    outline: none;
    box-shadow: 0 5px 5px 5px rgba(0, 0, 0, 0.01);
    background-color: transparent;
    transition: opacity 200ms ease;
    opacity: 0;
    overflow: hidden;

    &[data-placement^='top'] {
        border-bottom-width: 0px;
        border-top-right-radius: 2px;
        border-top-left-radius: 2px;
    }

    &[data-placement^='bottom'] {
        border-top-width: 0px;
        border-bottom-right-radius: 2px;
        border-bottom-left-radius: 2px;
    }

    &.entered {
        opacity: 1;
    }

    &.exiting .list {
        overflow-y: hidden;
    }
}

.arrow {
    height: 40px;
    width: 100%;
    border-radius: 0;

    border-width: 1px;
    border-style: solid;
    border-color: var(--color-shade-50);
    opacity: 0;
    transition: opacity 200ms ease;

    &[data-placement^='top'] {
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
        border-top-width: 0px;
    }

    &[data-placement^='bottom'] {
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        border-bottom-width: 0px;
    }

    &.entered {
        opacity: 1;
    }

    &::after {
        display: none;
    }
}

.list_sizer {
    background-color: var(--color-background);
    overflow: hidden;
    width: 100%;
}

.list {
    margin: 0;
    padding: 0;
    overflow-y: auto;
    max-height: 100%;
    pointer-events: all;
}

.list_item {
    padding: 0;
    margin: 0;
    display: block;
}

.empty_message,
.option {
    --background-color: transparent;
    --foreground-color: var(--color-text);

    display: flex;
    align-items: center;
    text-align: left;
    border: none;
    padding: 12px 20px;
    min-height: 40px;
    width: 100%;
    font-family: inherit;
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    background-color: var(--background-color);
    color: var(--foreground-color);
    transition-property: background-color, color;
    transition-duration: 200ms;
    transition-timing-function: ease;
    border-radius: 2px;

    &:hover {
        --background-color: var(--color-shade-20);
    }

    &:focus {
        --background-color: var(--color-shade-30);
    }

    &.active {
        --background-color: var(--color-secondary);
        --foreground-color: var(--color-secondary-contrast);
    }
}

/* 
    Safari gets confused if a button's child is a component,
    So we disable the pointer events on a button's child to ensure
    that the click comes from the button.
*/
.option > * {
    pointer-events: none;
}

.list[high-contrast] .option {
    &:hover {
        --background-color: transparent;
        --foreground-color: var(--color-secondary);
    }

    &:focus {
        --background-color: transparent;
        outline: dashed;
        outline-offset: -3px;
        outline-color: var(--color-text);
    }

    &.active {
        --background-color: var(--color-secondary);
        --foreground-color: var(--color-secondary-contrast);
    }
}

.empty_message {
    color: var(--color-shade-50);

    &:hover {
        background-color: transparent;
    }
}
